export default __webpack_public_path__ + "static/TSBO-8dc7e246eea973b38f8296b86b6b072c.jpg";